
export default {
    name: 'atcd-historique-adulte-familiaux',
    components: {},
    props: ["consultation", "activeRole"],
    data() {
        return {
            is_loading: true,
            histo_is_empty: false,
        }
    },
    computed: {
        antecedent_adulte_familiaux_historique() {
            return this.$store.getters["antecedent_adulte_familiaux_historique"];
        },
    },
    mounted() {
        this.listeChampATCDAdulteFamiliaux()
    },
    methods: {
        async listeChampATCDAdulteFamiliaux() {
            this.is_loading = true
            let filter_data = {
                consultation_id: this.consultation.id,
                data_type: 'antecedent_adulte_familiaux',
                est_en_cours: false
            }

            this.$store.dispatch('getConsultationAntecedent', filter_data).then(() => {
                if (this.antecedent_adulte_familiaux_historique.length == 0) {
                    this.histo_is_empty = true
                } else {
                    this.histo_is_empty = false
                }
                this.is_loading = false
            })
        },
    }
}


